import * as React from 'react';
import { Mutation } from 'react-apollo';

import gql from 'graphql-tag';
import _ from 'lodash';

import user from 'js/lib/user';

import type { Notification } from 'bundles/notification-center/types';

import type { NotificationCenterMessagesQueryResponse } from './NotificationCenterMessagesQuery';
import NotificationCenterMessagesQuery from './NotificationCenterMessagesQuery';

/* eslint-disable graphql/template-strings */
export const MarkAsReadQuery = gql`
  mutation MarkAsReadMutation {
    action(id: $id, input: {})
      @rest(
        method: "POST"
        type: "NotificationCenterMessagesV1"
        path: "notificationCenterMessages.v1/?action=markAsRead&id={args.id}"
      ) {
      id
    }
  }
`;
/* eslint-enable graphql/template-strings */

type MarkAsReadRenderProps = {
  markNotificationAsRead: (id: string) => void;
};

type MarkAsReadProps = {
  children: (renderProps: MarkAsReadRenderProps) => React.ReactElement | null;
};

type MarkAllAsReadMutationData = {};

type MarkAllAsReadMutationVariables = {
  id: string;
};

const NotificationCenterMarkAsReadMutation = ({ children }: MarkAsReadProps) => (
  <Mutation<MarkAllAsReadMutationData, MarkAllAsReadMutationVariables> mutation={MarkAsReadQuery}>
    {(markNotificationAsReadMutation) => {
      const markNotificationAsRead = (id: string) => {
        markNotificationAsReadMutation({
          variables: { id },
          update: (cache) => {
            let data: NotificationCenterMessagesQueryResponse | null = cache.readQuery({
              query: NotificationCenterMessagesQuery,
              variables: { userId: user.get().id.toString() },
            });
            data = _.cloneDeep(data);

            const notifications = data?.NotificationCenterMessagesV1Resource.elements;
            const notification = notifications?.find((n: Notification) => n.id === id);
            if (notification) {
              notification.isRead = true;
            }

            cache.writeQuery({
              query: NotificationCenterMessagesQuery,
              variables: { userId: user.get().id.toString() },
              data,
            });
          },
        });
      };

      return children({ markNotificationAsRead });
    }}
  </Mutation>
);

export default NotificationCenterMarkAsReadMutation;
